/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from "@vlinder-web/plugin-agent-service-react";
import {
  HeaderService,
  IHeaderMethods,
  HeroSectionService,
  IHeroSectionMethods,
  MainSectionService,
  IMainSectionMethods,
  FooterService,
  IFooterMethods,
  ImageFeatureSectionService,
  IImageFeatureSectionMethods,
  FeatureSectionService,
  IFeatureSectionMethods,
  StaticPageContentService,
  IStaticPageContentMethods,
} from "./components";

export type LandingPageAgent = IHeaderMethods &
  IHeroSectionMethods &
  IImageFeatureSectionMethods &
  IMainSectionMethods &
  IFeatureSectionMethods &
  IFooterMethods &
  IStaticPageContentMethods;

const getPlugins = () => {
  return [
    new HeaderService(),
    new HeroSectionService(),
    new ImageFeatureSectionService(),
    new MainSectionService(),
    new FeatureSectionService(),
    new FooterService(),
    new StaticPageContentService(),
  ];
};

export const getAgent = () => {
  return createAgent<LandingPageAgent>({
    plugins: getPlugins(),
  });
};
